import { render, staticRenderFns } from "./SyncOpportunities.vue?vue&type=template&id=59f9dac8"
import script from "./SyncOpportunities.vue?vue&type=script&lang=js"
export * from "./SyncOpportunities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports